import { Button } from 'components/ui/button'
import { ENV, dotenv } from 'config/dotenv.config'
import { toastConfig } from 'config/toasts.config'
import { urlConfig } from 'config/url.config'
import { memo, useCallback, useMemo } from 'react'
import { useGetProjectsQuery } from 'redux/api/project-api'
import { ProjectSchemaType, ProjectStatus } from 'types/schemas/project.schema'
import { cn } from 'utils/cn'

interface DashboardStatusCellProps extends React.ComponentProps<typeof Button> {
    id: ProjectSchemaType['id']
    status: ProjectSchemaType['status']
}
export const DashboardStatusCell: React.FC<DashboardStatusCellProps> = memo(({ id, status, className, ...props }) => {
    const { refetch } = useGetProjectsQuery()

    const buttonVariant = useMemo(() => {
        if (status === ProjectStatus.OK) return 'success'
        if (status === ProjectStatus.DOWN) return 'destructive'
        if (status === ProjectStatus.REDIRECT) return 'destructive'
        return 'ghost'
    }, [status])

    const onClick = useCallback(async () => {
        try {
            const res = await fetch(`${dotenv.get(ENV.API_URL)}${urlConfig.api.revalidate}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    projectId: id,
                }),
            })
            if (!res.ok) {
                throw new Error('Failed to revalidate')
            }
            refetch()
            toastConfig.refetch.success()
        } catch (error) {
            console.error(error)
            toastConfig.refetch.error()
        }
    }, [id, refetch])

    return (
        <Button variant={buttonVariant} size="sm" onClick={onClick} {...props} className={cn('uppercase', className)}>
            {status}
        </Button>
    )
})
DashboardStatusCell.displayName = 'DashboardStatusCell'
